import React from 'react';
import { MMediaImage } from '../../molecules/MMediaImage/index';
import { MTextBlockBasic } from '../../molecules/MTextBlockBasic/index';
import { AIcon } from '../../atoms/AIcon/index';
import * as Styled from './OCardBrowse.styles';
import type { OCardBrowseProps } from './OCardBrowse.types';

export const OCardBrowse: React.FC<OCardBrowseProps> = ({
  componentId,
  mMediaImage,
  mTextBlockBasic,
  aIcon,
  ctaLink,
  trackingProperties,
  className,
  ...rest
}) => {
  const handleCardClick = () => {
    console.log('Card clicked:');
    if (ctaLink) {
      if (trackingProperties?.clickTrack) {
        console.log('Card clicked:', { ctaLink, trackingProperties });
      }
      window.location.href = ctaLink;
    }
  };

  return (
    <Styled.Wrapper
      data-component-id={componentId}
      className={className}
      onClick={handleCardClick}
      role={ctaLink ? 'link' : undefined}
      tabIndex={ctaLink ? 0 : undefined}
      {...rest}
    >
      <Styled.MediaContainer>
        {mMediaImage && <MMediaImage {...mMediaImage} />}
        {aIcon && (
          <Styled.IconOverlay>
            <AIcon {...aIcon} />
          </Styled.IconOverlay>
        )}
      </Styled.MediaContainer>
      <Styled.ContentContainer>
        <Styled.TextArrowWrapper>
          {mTextBlockBasic && <MTextBlockBasic {...mTextBlockBasic} />}
          {ctaLink && (
            <Styled.CtaArrow>
              <AIcon icon="icon-arrow-right" />
            </Styled.CtaArrow>
          )}
        </Styled.TextArrowWrapper>
      </Styled.ContentContainer>
    </Styled.Wrapper>
  );
};

export type { OCardBrowseProps };
